import { useResizeObserver } from './useResizeObserver';

export const useHeightResizeObserver = (): [any, number] => {
	// eslint-disable-next-line
	const [ref, _, height] = useResizeObserver();
	return [ref, height];
};
